import { render } from "./TransitionExpand.vue?vue&type=template&id=6f5a7968"
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__